import { FunctionComponent, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";

/**
 * Old bookmarked /collection?projectId=...&... links redirect here to the new
 * path-based /:projectId/form route, preserving every other query param.
 */
const LegacyCollectionRedirect: FunctionComponent = () => {
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const projectId = params.get("projectId");
    if (!projectId) return;
    params.delete("projectId");
    const rest = params.toString();
    history.replace(`/${projectId}/form${rest ? `?${rest}` : ""}`);
  }, [location, history]);

  return null;
};

export default LegacyCollectionRedirect;
